import type { DeliveryType } from "@types_def/models/delivery.types";

import { deliveryTypeAttributes } from "@utils/constants/DeliveryType/deliveryTypeAttributes";

export function getDeliveryTypeAttributes(deliveryType: DeliveryType) {
  return deliveryTypeAttributes.find((c) => c.key === deliveryType) ?? deliveryTypeAttributes[0];
}

export function getDeliveryTypeColor(deliveryType: DeliveryType) {
  return getDeliveryTypeAttributes(deliveryType).color;
}

export function getDeliveryTypeAcronym(deliveryType: DeliveryType) {
  return getDeliveryTypeAttributes(deliveryType).acronym;
}

export function getDeliveryTypeTitle(deliveryType: DeliveryType) {
  return getDeliveryTypeAttributes(deliveryType).title;
}
